import { render, staticRenderFns } from "./datafile-result.vue?vue&type=template&id=2a9c5574"
import script from "./datafile-result.vue?vue&type=script&lang=js"
export * from "./datafile-result.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports